export default __webpack_public_path__ + "images/3a1df4996c2f1da7966e987c4668987b-YGP_citybrowseheader_CHI_791x488px@2x.webp";